<h2 class="center_text" mat-dialog-title>{{'Error500.error_500_message' | translate}}</h2>
<button class="button_error500" mat-stroked-button color="warn" type="submit" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
